import * as React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface Props {
  dialogId: string;
  open: boolean;
  onClose: () => void;
  onAgree: () => void;
  title: string;
  contextText: string;
  cancelActionText: string;
  continueActionText: string;
}

const AlertDialog: React.FC<Props> = ({
  dialogId,
  open,
  onClose,
  onAgree,
  title,
  contextText,
  cancelActionText,
  continueActionText,
}: Props) => {
  return (
    <Dialog
      id={dialogId}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          dangerouslySetInnerHTML={{ __html: contextText }}
        >
          {/* {contextText} */}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>{cancelActionText}</Button>
        <Button id={`${dialogId}-continue`} onClick={onAgree} autoFocus>
          {continueActionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
